import { render, staticRenderFns } from "./welcome-widget.component.vue?vue&type=template&id=689b2d76&scoped=true"
import script from "./welcome-widget.component.vue?vue&type=script&lang=ts"
export * from "./welcome-widget.component.vue?vue&type=script&lang=ts"
import style0 from "./welcome-widget.component.vue?vue&type=style&index=0&id=689b2d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689b2d76",
  null
  
)

export default component.exports